export default __webpack_public_path__ + "svg/ceo/internationalization.svg?96ee6023";